import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Asterisk, TrendingUp, Star, TriangleAlert, Phone } from 'lucide-react';
import { VET_BENEFITS, VET_PLANS } from '../mock';

const ICONS = { TrendingUp, Star, TriangleAlert, Phone };

export default function VetLanding() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background pb-28">
      <div className="mx-auto max-w-4xl px-5 py-6">
        <button onClick={() => nav('/')} className="mb-5 inline-flex h-10 w-10 items-center justify-center rounded-full hover:bg-secondary">
          <ChevronLeft className="h-5 w-5" />
        </button>

        <div className="animate-fade-up">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-accent">
            <Asterisk className="h-8 w-8 text-[hsl(var(--coral))]" />
          </div>
          <h1 className="mt-4 text-4xl font-extrabold tracking-tight">Reach more cat parents.</h1>
          <p className="mt-2 max-w-lg text-muted-foreground">Join Purrflect’s veterinary network. Get featured, receive direct inbound calls, and grow your clinic.</p>
        </div>

        <div className="mt-8 space-y-3">
          {VET_BENEFITS.map((b, i) => {
            const Icon = ICONS[b.icon];
            return (
              <div key={b.title} className="card-soft flex items-start gap-4 rounded-2xl bg-secondary/60 p-4 animate-fade-up" style={{ animationDelay: `${i * 60}ms` }}>
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent">
                  <Icon className="h-5 w-5 text-[hsl(var(--coral))]" />
                </div>
                <div>
                  <h3 className="font-bold">{b.title}</h3>
                  <p className="text-sm text-muted-foreground">{b.desc}</p>
                </div>
              </div>
            );
          })}
        </div>

        <h2 className="mt-10 text-2xl font-extrabold tracking-tight">Simple monthly pricing</h2>
        <div className="mt-4 grid gap-4 sm:grid-cols-2">
          {VET_PLANS.map((p) => (
            <div key={p.id} className={`relative rounded-2xl border-2 bg-white p-6 text-center card-soft ${p.best ? 'border-[hsl(var(--coral))] bg-accent/40' : 'border-border'}`}>
              {p.best && <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[hsl(var(--coral))] px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-white">Best</span>}
              <p className="font-bold">{p.name}</p>
              <p className="mt-2"><span className="text-4xl font-extrabold text-[hsl(var(--coral))]">${p.price}</span><span className="text-sm text-muted-foreground">/month</span></p>
              <p className="mt-1 text-xs text-muted-foreground">or ${p.bundlePrice}/mo for both Purrflect + Wooflect</p>
              <ul className="mt-4 space-y-1.5 text-left text-sm text-muted-foreground">
                {p.perks.map((x) => <li key={x} className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-[hsl(var(--coral))]" />{x}</li>)}
              </ul>
            </div>
          ))}
        </div>
        <p className="mt-4 text-center text-sm text-muted-foreground">Cancel anytime · No setup fees · Stripe-secured</p>
      </div>

      <div className="fixed inset-x-0 bottom-0 border-t border-border bg-background/95 px-5 py-4 backdrop-blur">
        <div className="mx-auto max-w-4xl">
          <button onClick={() => nav('/vets/signup')} className="coral-btn w-full rounded-2xl py-4 text-base font-bold text-white">Create a vet account</button>
          <p className="mt-2 text-center text-sm text-muted-foreground">Already have a vet account? <span className="font-bold text-foreground">Sign in</span></p>
        </div>
      </div>
    </div>
  );
}
